module.exports = __webpack_public_path__ + "static/img/icon_info-2.60c6e05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/icon_info-2.svg
// module id = 8v+2
// module chunks = 1